class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = this.getTemplate().replaceAll('<slot/>', this.innerHTML);

    this.overlay = this.querySelector('.modal-overlay');
    this.modal = this.querySelector('.modal-content');

    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.initEventListeners();
  }

  initEventListeners() {
    document.querySelectorAll(`[data-modal="${this.getAttribute('name')}"]`).forEach((element) => {
      element.addEventListener('click', this.open)
    });
    this.querySelectorAll(`[data-action="close"]`).forEach((element) => {
      element.addEventListener('click', this.close)
    });
    this.overlay.addEventListener('click', this.close);
  }

  open() {
    this.classList.add('opened');
  }

  close() {
    this.classList.remove('opened');
  }

  getTemplate() {
    return  `
      <div class="modal">
        <div class="modal-overlay ${this.dataset.overlay || ''}"></div>
        <div class="modal-content ${this.dataset.content || ''}">
          <slot/>
        </div>
      </div>
    `;
  }

  disconnectedCallback() {
    document.querySelectorAll(`[data-modal="${this.getAttribute('name')}"]`).forEach((element) => {
      element.removeEventListener('click', this.open)
    });
    this.querySelectorAll(`[data-action="close"]`).forEach((element) => {
      element.removeEventListener('click', this.close)
    });
    this.overlay.removeEventListener('click', this.close);
  }
}

if (!customElements.get('modal-dialog')) {
  customElements.define('modal-dialog', ModalDialog);
}
